<div class="container">
  <li *ngFor="let room of chatRooms" class="py-1 border-bottom-1 surface-border " (click)="selectChat(room)">
    <div class="avatar">
      <div class="char">{{getRoomName(room).toUpperCase().substr(0, 1)}}</div>
    </div>
    <span class="name text-900 clamp-one-row">{{getRoomName(room)}}</span>
    <div class="last-message text-700 clamp-one-row" [innerHtml]="getRoomPreview(room)"></div>
    <span class="time text-500 clamp-one-row">{{getRoomLastMessageTimestamp(room)}}</span>
    <div class="flex align-items-start mr-0 lg:mr-5">
      <div>
      </div>
    </div>
  </li>
</div>
